import { useEffect } from 'react';

import { monitorForElements } from '@atlaskit/pragmatic-drag-and-drop/element/adapter';
import { extractClosestEdge } from '@atlaskit/pragmatic-drag-and-drop-hitbox/closest-edge';
import { reorderWithEdge } from '@atlaskit/pragmatic-drag-and-drop-hitbox/util/reorder-with-edge';
import PropTypes from 'prop-types';

import DraggableListItem from './DraggableListItem';

const DraggableList = ({ list, setList }) => {
  const onRemoveFromList = (index) => {
    const updatedList = list.filter((_, i) => index !== i);
    setList(updatedList);
  };

  useEffect(() => {
    return monitorForElements({
      onDrop({ location, source }) {
        const target = location.current.dropTargets[0];

        if (!target) return;

        const indexOfSource = list.findIndex(
          (item) => item.id === source.data.itemId
        );
        const indexOfTarget = list.findIndex(
          (item) => item.id === target.data.itemId
        );

        if (indexOfTarget < 0 || indexOfSource < 0) return;

        setList(
          reorderWithEdge({
            list: list,
            startIndex: indexOfSource,
            indexOfTarget: indexOfTarget,
            closestEdgeOfTarget: extractClosestEdge(target.data),
            axis: 'vertical',
          })
        );
      },
    });
  }, [list]);

  return (
    <ul style={{ listStyleType: 'none', margin: 0, padding: 0 }}>
      {list.map((item, index) => (
        <DraggableListItem
          item={item}
          index={index}
          key={item.id}
          onRemoveFromList={onRemoveFromList}
        />
      ))}
    </ul>
  );
};

DraggableList.propTypes = {
  list: PropTypes.array,
  setList: PropTypes.func.isRequired,
};

export default DraggableList;
